import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';

export const TeamsApp: ComponentType<unknown> & LoadableExport.LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "goals-app-entry" */ '@townsquare/teams/app'),
	loading: () => null,
});
